import {CountryResponseBody} from '@dms/api/shared';

export const prioritizedCountriesResponseMock: CountryResponseBody[] = [
  {
    code: 'CZE',
    name: 'Czech Republic',
    preferred: true,
    primaryCurrency: 'CZK',
  },
  {
    code: 'SVK',
    name: 'Slovakia',
    preferred: true,
    primaryCurrency: 'EUR',
  },
  {
    code: 'POL',
    name: 'Poland',
    preferred: true,
    primaryCurrency: 'PLN',
  },
  {
    code: 'DEU',
    name: 'Germany',
    preferred: true,
    primaryCurrency: 'EUR',
  },
  {
    code: 'AUT',
    name: 'Austria',
    preferred: true,
    primaryCurrency: 'EUR',
  },
];
